import React from 'react';
import { Form } from 'react-bootstrap';
import Button from '../../components/Button/Button';
import { termOptions } from '../../utils/helper';
import Select from '../../components/Select/Select';
import Input from '../../components/Input/Input';
import AssignmentGrid from '../../components/AssignmentGrid/AssignmentGrid';

const TemplateFrom = (
  {
    handleSubmit, handleChange, term, template_path,
    type, publish_date, program_ids, programData,
    handleSwitchChange, handleInputChange,
  }
) => {
  return (
    <Form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-md-6 mb-3">
          <Select
            label={'Term'}
            name="term"
            value={term}
            onChangeHandler={handleChange}
            options={termOptions}
            placeholder="Select Term"
          />
        </div>
        <div className="col-md-6 mb-3">
          <Input
            label="Path"
            type="text"
            name="template_path"
            onChange={handleChange}
            placeholder="Enter path"
            value={template_path}
            required={true}
          />
        </div>
        <div className="col-md-6 mb-3">
          <Select
            label={'Type'}
            name="type"
            value={type}
            onChangeHandler={handleChange}
            options={[
              { id: 0, name: 'Template' },
              { id: 1, name: 'Excel' }]
            }
            placeholder="Select Type"
          />
        </div>
        <div className="col-md-6 mb-3">
          <Input
            label="Publish Date"
            type="date"
            name="publish_date"
            onChangeHandler={handleChange}
            placeholder="Enter Publish Date"
            value={publish_date}
            required={true}
          />
        </div>

        <AssignmentGrid
          label="Available for classes"
          items={programData}
          selectedIds={program_ids}
          onToggle={handleInputChange}
          onSelectAll={handleSwitchChange}
          switchName="program_ids"
        />
      </div>
      <div className="row justify-content-end mt-3">
        <div className="col-md-1">
          <Button variant="success" type="submit">
            Submit
          </Button>
        </div>
      </div>
    </Form>
  );
};

export default TemplateFrom;
